import { createContextHook } from '@/utils';
import { PopoverContext } from './PopoverContext';

export const usePopoverContext = createContextHook(PopoverContext);
